export class TimeFrame {
    public static AvailableTimeFrames: TimeFrame[] = new Array<TimeFrame>();

    public static CurrentLocation = new TimeFrame(1, 'Current Location');
    public static LastHour = new TimeFrame(2, 'Last Hour');
    public static Last2Hours = new TimeFrame(3, 'Last 2 Hours');
    public static Last5Hours = new TimeFrame(4, 'Last 5 Hours');
    public static Last10Hours = new TimeFrame(5, 'Last 10 Hours');
    public static Last24Hours = new TimeFrame(6, 'Last 24 Hours');
    // public static EnterADate = new TimeFrame(7, 'Enter a Date', true);
    public static DateRange = new TimeFrame(8, 'Date Range', true);

    public readonly displayOrder: number;
    public readonly displayText: string;
    public readonly isSelectableDate: boolean;

    constructor(displayOrder: number, displayText: string, isSelectableDate: boolean = false) {
        this.displayOrder = displayOrder;
        this.displayText = displayText;
        this.isSelectableDate = isSelectableDate;

        TimeFrame.AvailableTimeFrames =
            [...TimeFrame.AvailableTimeFrames, this]
                .sort((x, y) => x.displayOrder > y.displayOrder ? 1 : -1)
        ;
    }
}
